import { ElMessage } from 'element-plus'

export default function useFlash() {
  const triggerAlert = (val) => {
    if (val?.error) ElMessage.error(val.error)
  }
  const triggerSuccess = (val, oldVal) => {
    if (val?.message && val.message !== oldVal?.message) ElMessage.success(val.message)
  }
  const triggerFlash = (val, oldVal) => {
    triggerAlert(val)
    triggerSuccess(val, oldVal)
  }

  return {
    triggerAlert,
    triggerSuccess,
    triggerFlash
  }
}
